@if (appService.languages) {
	@switch (options?.display) {
		@case ('miniFab') {
			<button matMiniFab [matMenuTriggerFor]="translationMenu" style="position: absolute; inset-inline-end: 1rem; inset-block-start: 1rem; z-index: 1;">
				<mat-icon svgIcon="globe"></mat-icon>
			</button>
		}
		@default {
			<button mat-icon-button color="accent" [matMenuTriggerFor]="translationMenu">
				<mat-icon svgIcon="language" class="rotate-rtl"></mat-icon>
			</button>
		}
	}
	<mat-menu #translationMenu="matMenu">
	@if (options?.aiMode) {
		<h6 class="dropdown-header">{{ 'chat_language' | cTranslate }}</h6>
		@for (lng of appService.aiLocals; track lng.value) {
			<button mat-menu-item (click)="appService.setAiLocale(lng)"
					[class.active]="lng.id === appService.aiLocale.id">
				<span>{{ lng.name }}</span>
			</button>
		}
	} @else {
		@for (lng of appService.languages; track lng.value) {
			<button mat-menu-item (click)="appService.setLocale(lng.value)"
					[class.active]="lng.value === appService.locale">
				<span>{{ lng.text }}</span>
			</button>
		}
	}
	</mat-menu>
}
